import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import VuexPersistence from "vuex-persist";

import Cookies from "js-cookie";

import user from "@/store/_user";

Vue.use(VueResource);
Vue.use(Vuex);

const storageKey = "uOEOCRFfVy";

const localStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    // user: state.customer,
  })
});

const sessionStorage = new VuexPersistence({
  key: storageKey,
  storage: window.sessionStorage,
  reducer: state => ({
    user: state.user
  })
});

// const cookieStorage = new VuexPersistence({
//   key: storageKey,
//   restoreState: (key, storage) => Cookies.getJSON(key),
//   saveState: (key, state, storage) =>
//     Cookies.set(key, state, {
//       expires: 3
//     }),
//   reducer: state => ({
//     customer: {
//       customerId: state.customer.customerId,
//       sessionToken: state.customer.sessionToken
//     }
//   })
// });

const store = new Vuex.Store({
  state: {
  },
  modules: {
    user
  },
  getters: {
    isLoggedIn: state => {
      if (state.user.authKey != '' && state.user.userName != '') {
        return true;
      } else {
        return false;
      }
    },
    isParent: state => {
      return state.user.userIsParent
    },
    userName: state => {
      return state.user.userName
    },
    userId: state => {
      return state.user.userId
    },
    userRole: state => {
      return state.user.userRole
    },
    userType: state => {
      return state.user.userType
    },
    userCompany: state => {
      return state.user.userCompany
    },
    authKey: state => {
      return state.user.authKey
    },
    apiKey: state => {
      return state.user.apiKey
    },
    redirectRoute: state => {
      if (state.user.userRole == 'admin')
        return '/portal/admin/package'
      if (state.user.userRole == 'user')
        return '/portal/user/package'
    }
  },
  plugins: [
    localStorage.plugin,
    sessionStorage.plugin
  ],
  mutations: {
  },
  actions: {

  }
});

export default store;